import GeneralClinicReportPhase from '@/components/AttendanceForm/general-clinic/phase/GeneralClinicReportPhase.vue'
import { PSYCHIATRIC_SCREENING_PERIODICITY } from '@/components/AttendanceForm/general/constants/psychiatricScreening'
import ExaminationsPhase from '@/components/AttendanceForm/general/phase/ExaminationsPhase'
import FlaresPhase from '@/components/AttendanceForm/general/phase/FlaresPhase.vue'
import ImagePhase from '@/components/AttendanceForm/general/phase/ImagePhase.vue'
import MedicinesPhase from '@/components/AttendanceForm/general/phase/MedicinesPhase.vue'
import PsychiatricScreeningPhase from '@/components/AttendanceForm/general/phase/PsychiatricScreeningPhase.vue'
import SimplePhase from '@/components/AttendanceForm/general/phase/SimplePhase.vue'
import VaccinationPhase from '@/components/AttendanceForm/general/phase/VaccinationPhase.vue'
import { AttendanceConfig } from './AttendanceConfig'

export default new AttendanceConfig()
  .addStep('Anamnese')
  .addPhase('dados_especificos', 'Dados específicos', SimplePhase, generateNotesOverview)
  .addPhase('investigacao_pessoal', 'Investigação pessoal', SimplePhase, generateNotesOverview)
  .addPhase('investigacao_familiar', 'Investigação familiar', SimplePhase, generateNotesOverview)
  .addPhase(
    'triagem_psiquiatrica',
    'Triagem psiquiátrica',
    PsychiatricScreeningPhase,
    generatePsychiatricScreenOverview,
  )
  .addStep('Exame físico')
  .addPhase('exames', 'Exames', ExaminationsPhase)
  .addPhase('crises', 'Crises (Flares)', FlaresPhase, generateNotesOverview)
  .addPhase('vacinas', 'Vacinas', VaccinationPhase, generateNotesOverview)
  .addPhase('dados', 'Dados', SimplePhase, generateNotesOverview)
  .addPhase('imagens', 'Imagens', ImagePhase)
  .addStep('Resultados')
  .addPhase('report', 'Relatório', GeneralClinicReportPhase, generateReportOverview)
  .addPhase('medicamentos', 'Medicamentos', MedicinesPhase)

function generateNotesOverview(data, attendance) {
  if (data?.notes) {
    return data.notes.split(/\n/)
  }

  return []
}

function generateReportOverview(data, attendance) {
  const cidSymptoms = attendance.data.report?.symptoms || []
  const paragraphs = []
  if (cidSymptoms.length > 0) {
    paragraphs.push('<strong>CID e sintomas:</strong>')
    cidSymptoms.map((c) => c.name).forEach((c) => paragraphs.push(`- ${c}`))
    paragraphs.push('')
  }
  return paragraphs.concat(generateNotesOverview(data, attendance))
}

function generatePsychiatricScreenOverview(data, attendance) {
  if (!data) {
    return []
  }

  const paragraphs = []

  if (data.profile) {
    if (data.profile['nervoso_ansioso_limite_duas_ultimas_semanas']?.value) {
      const periodicityKey = data.profile['nervoso_ansioso_limite_duas_ultimas_semanas'].value
      const periodicityName = PSYCHIATRIC_SCREENING_PERIODICITY.find((period) => period.value === periodicityKey).text
      paragraphs.push(`Nas duas últimas semanas o quão frequentemente você se sentiu nervoso, ansioso ou no limite?`)
      paragraphs.push(`<strong>Resposta:</strong> ${periodicityName}`)
      paragraphs.push('')
    }

    if (data.profile['incapaz_controlar_preocupacoes_duas_ultimas_semanas']?.value) {
      const periodicityKey = data.profile['incapaz_controlar_preocupacoes_duas_ultimas_semanas'].value
      const periodicityName = PSYCHIATRIC_SCREENING_PERIODICITY.find((period) => period.value === periodicityKey).text
      paragraphs.push(
        `Nas duas últimas semanas o quão frequentemente você se sentiu incapaz de impedir ou controlar suas preocupações?`,
      )
      paragraphs.push(`<strong>Resposta:</strong> ${periodicityName}`)
      paragraphs.push('')
    }

    if (data.profile['pouco_interesse_prazer_duas_ultimas_semanas']?.value) {
      const periodicityKey = data.profile['pouco_interesse_prazer_duas_ultimas_semanas'].value
      const periodicityName = PSYCHIATRIC_SCREENING_PERIODICITY.find((period) => period.value === periodicityKey).text
      paragraphs.push(
        `Nas duas últimas semanas quantos dias você teve pouco interesse ou pouco prazer em fazer as coisas?`,
      )
      paragraphs.push(`<strong>Resposta:</strong> ${periodicityName}`)
      paragraphs.push('')
    }
    if (data.profile['deprimido_duas_ultimas_semanas']?.value) {
      const periodicityKey = data.profile['deprimido_duas_ultimas_semanas'].value
      const periodicityName = PSYCHIATRIC_SCREENING_PERIODICITY.find((period) => period.value === periodicityKey).text
      paragraphs.push(`Nas duas últimas semanas quantos dias você se sentiu para baixo, deprimido ou sem perspectiva?`)
      paragraphs.push(`<strong>Resposta:</strong> ${periodicityName}`)
      paragraphs.push('')
    }
  }

  paragraphs.push(...generateNotesOverview(data, attendance))

  return paragraphs
}
